export const getBirthAge = (date: any) => {
  const age = date.slice(0, 4);  
  return age;
};
